<template>
  <div class="material-list">
    <div v-if="materialLimit" class="material-limit">{{ `（${materialData.length}/${materialLimit}）` }}</div>
    <div v-if="materialData.length" class="material-content">
      <div
        v-for="(item, index) in materialData"
        :key="index"
        class="material-item"
      >
        <el-card>
          <div class="item-content" style="position: relative;">
            <el-image
              fit="contain"
              :src="item.url[0].thumb_url"
            />
            <div v-if="!isPreview" class="img-func">
              <el-button
                class="el-button-scale"
                icon="el-icon-zoom-in"
                circle
                @click.stop="openViewer(materialData, index)"
              />
            </div>
          </div>
          <i
            v-if="!isPreview"
            class="el-icon-error item-close"
            @click="delectMaterial(materialData, index)"
          />
          <el-tooltip effect="dark" :content="item.name" placement="bottom-start">
            <div class="title">{{ item.name }}</div>
          </el-tooltip>
        </el-card>
      </div>
    </div>
    <el-empty v-else :image-size="100" description="暂无数据" />
    <el-image-viewer
      v-if="show_viewer"
      :z-index="3000"
      :initial-index="url_index"
      :on-close="() => show_viewer = false"
      :url-list="url_list"
    />
  </div>
</template>

<script>
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  model: {
    prop: 'materialData', // 指向props的参数名
    event: 'change', // 事件名称
  },
  props: {
    /** 是否为预览状态 */
    isPreview: {
      type: Boolean,
      default: false,
    },
    /** 素材数据 */
    materialData: {
      type: Array,
      required: true,
    },
    /** 素材限制 */
    materialLimit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show_viewer: false,
      url_list: [],
    };
  },
  methods: {
    // 打开预览幻灯片
    openViewer: function(list, index) {
      this.url_list = list.map((item) => {
        return item.url[0].thumb_url;
      });
      this.url_index = index;
      this.show_viewer = true;
    },
    // 删除素材
    delectMaterial: function(list, index) {
      list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-card {
  width: 100%;
  height: 100%;
  overflow: initial;
  .el-card__body {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }
}
.el-empty {
  height: 220px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
}
.material-list {
  .material-limit {
    text-align: right;
  }
  .material-content {
    padding: 10px;
    height: 220px;
    overflow: auto;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    .material-item {
      display: inline-block;
      width: 20%;
      height: 100%;
      padding: 10px;
      .item-content {
          flex:1;
          min-height: 0;
        }
      .el-image {
        width: 100%;
        height: 100%;
        background-color: #333;
        object-fit: contain
      }
      .img-func {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden;
        transition: all .3s;
        .el-button.el-button-scale {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 36px;
          height: 36px;
          margin: auto;
          background-color: #3333336e; color: #fff;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
      .item-close {
        position: absolute;
        right: -5px;
        top: -5px;
        font-size: 15px;
        cursor: pointer;
      }
    }
  }
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

</style>
